module.exports = "<div baCardBlur class=\"animated fadeIn card {{cardType}} {{baCardClass || ''}}\" id=\"{{cardId || ''}}\" zoom-in>\n    <div *ngIf=\"cardTitle\" class=\"card-header clearfix\">\n        <h3 class=\"card-title\" style=\"font-weight:bold\" translate>{{cardTitle}}</h3>\n        </div>\n    <div class=\"card-body\">\n        <ng-content></ng-content>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baCard/baCard.html
// module id = ./src/app/theme/components/baCard/baCard.html
// module chunks = main